import React, { useEffect, useState } from "react";

import NotchCalendar from 'components/NotchCalendar'

import axiosInstance from "utils/axiosInstance";
import { useLocalStorage } from 'utils/storage';

import "./styles.css";

const Sandbox = () => {
	const today = new Date().toLocaleDateString("en-CA");
	const [selectedDate, setSelectedDate] = useLocalStorage('selectedDate', today);
	const [daysWithNotches, setDaysWithNotches] = useLocalStorage('daysWithNotches', []);
	const [notches, setNotches] = useLocalStorage('notches', []);
    const [notchTypes, setNotchTypes] = useState([
        { type: "notch", name: "Notch" },
        { type: "memory", name: "Memory" },
        { type: "milestone", name: "Milestone" },
        { type: "thought", name: "Thought" },
        { type: "achievement", name: "Achievement" },
        { type: "idea", name: "Idea" },
    ]);

	const handleAddItem = async (form) => {
        try {
            let response;

            if (form.uid) {
                response = await axiosInstance.post(`/api/notches/${form.uid}`, form);
            } else {
                response = await axiosInstance.post("/api/notches", form);
            }

            const itemInResponse = response.data.data;

            setNotches((currentItems) => {
                const isEditing = currentItems.some(n => n.uid === itemInResponse.uid);
    
                if (isEditing) {
                    return currentItems.map(item =>
                        item.uid === itemInResponse.uid ? itemInResponse : item
                    );
                } else {
                    const alreadyExists = daysWithNotches.includes(itemInResponse.date);
    
                    if (!alreadyExists) {
                        setDaysWithNotches(prev => [...prev, itemInResponse.date]);
                    }

                    return [...currentItems, itemInResponse];
                }
            });
        } catch (error) {
            console.error('Failed to save notch:', error);
        }
    };

    const handleDeleteNotch = async (uid) => {
        try {
            await axiosInstance.delete(`/api/notches/${uid}`);

            setNotches((notches) => notches.filter(n => n.uid !== uid));

            setNotches((currentNotches) => {
                const remainingNotchesForDate = currentNotches.filter(n => n.date === selectedDate);

                if (remainingNotchesForDate.length === 0) {
                    setDaysWithNotches((days) => days.filter(date => date !== selectedDate));
                }

                return currentNotches;
            });
        } catch (error) {
            console.error('Failed to delete notch:', error);
        }
    };

    return (
		<div>
			<div className="container">
				<div className="main-content">
			
					<div className="row">
						<h2 className="text-secondary align-self-start">
							Notches
						</h2>
					</div>


					<div className="row">
		
						<div className="col-md-4">

							<div className="card align-items-center">
								<NotchCalendar
                                    selectedDate={selectedDate}
                                    setSelectedDate={setSelectedDate}
                                    setNotches={setNotches}
                                    setDaysWithNotches={setDaysWithNotches}
                                    daysWithNotches={daysWithNotches}
                                />
							</div>

							<div className="card">
								<div className="card-body">
									<ul className="list-group">
										<li className="list-group-item">Перший елемент</li>
									</ul>
								</div>
							</div>


						</div>

						<div className="col-md-1">

						</div>

						<div className="col-md-7">
							<div className="card">

							</div>
						</div>
					</div>
				</div>
			</div>

			<nav className="navbar fixed-bottom bottom-menu">
				<div className="container">
					<ul className="nav justify-content-center w-100">
						<li className="nav-item">
							<a className="nav-link" href="#">Notches</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#">Collections</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#">Settings</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#">Sandbox</a>
						</li>
					</ul>
				</div>
			</nav>
		</div>
    );
};

export default Sandbox;
